import React from "react";
import classnames from 'classnames'
import { withLocalize, Translate } from "react-localize-redux";
import { isNullOrUndefined } from "../../store/storeFunctions";
import { Formik, Form } from "formik";
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHtmlParser from "react-html-parser";
import { apiGet, apiPost, getHostApi } from '../../store/apiWrapper';
import { writeErr } from '../common/logger';
import { mergeInto } from '../../store/storeFunctions';
import Section from "../common/section";
import BbInput from "../styling/bbInput";
import Message from "../common/message";
import SvgSipky from "../../img/icons/BBiconsRozbalitVse"

import "./skyminder.scss";

const orderStatus = {
    new: 1,
    submitting: 2,
    submitted: 3,
    failed: 4
};

const defaultValues = {
    companyName: "",
    companyId: "",
    street: "",
    city: "",
    zipCode: "",
    personName: "",
    personSurname: "",
    phone: "",
    email: ""
};

class SkyminderComponent extends React.Component {
    state = {
        userData: defaultValues,
        orderStatus: orderStatus.new
    }


    render() {
        return (
            <div className="content-root">
                <div className="card card-special">
                    <div className="card-body">
                        <div className="columns is-centered is-multiline">
                            <div className="column is-12" style={{ padding: "2em 2em 1.5em 2em" }}>
                                <div className="skyminder-description">
                                    {this.getDescription()}
                                </div>
                                {this.state.orderStatus !== orderStatus.submitted
                                    ? this.renderOrderForm()
                                    : <Message type="success" message={this.props.translate("SkyMinder.OrderForm.Success")} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        apiGet(`${getHostApi()}/api/skyminder/user`,
            null,
            (success) => {
                if (!isNullOrUndefined(success) && !isNullOrUndefined(success.data))
                    this.setState({ userData: success.data })
            },
            (error) => writeErr(error)
        );
    }

    getDescription = () => {
        const desc = ReactHtmlParser(this.props.translate("SkyMinder.Description"));
        const top = desc.filter(f => f.type === "span" && f.props.className === "top").shift();
        const bottom = desc.filter(f => f.type === "span" && f.props.className === "bottom").shift();
        const descList = desc.filter(f => f.type === "ul" && f.props.className === "list-arrow").shift()

        if (isNullOrUndefined(top) || isNullOrUndefined(bottom) || isNullOrUndefined(descList))
            return null;

        return (
            <React.Fragment>
                {top}
                <div className="skyminder-description-list">
                    {descList.props.children.map((x, i) => <div key={i} className="skyminder-description-list-item">
                        <SvgSipky className="skyminder-description-list-item-icon" />
                        <span className="skyminder-description-list-item-value">{x.props.children.shift()}</span>
                    </div>)}
                </div>
                {bottom}
            </React.Fragment>
        )
    }

    renderOrderForm = () => {
        return (
            <Section name={this.props.translate("SkyMinder.OrderForm")} isOpen={true}>
                <Formik
                    onSubmit={(values) => this.submitSearch(values)}
                    initialValues={mergeInto({ ...defaultValues }, this.state.userData)}
                    enableReinitialize={true}
                >
                    <Form noValidate>
                        <div className="skyminder-order-form">
                            <div className="columns is-centered is-multiline">
                                <div className="column is-6-widescreen is-12">
                                    <div className="columns is-centered is-multiline is-gapless">
                                        <div className="column is-12 skyminder-order-form-first-row">
                                            <BbInput type="text" name="companyName" disabled={true}
                                                label={this.props.translate("SkyMinder.OrderForm.CompanyName")}
                                            />
                                        </div>
                                        <div className="column is-12">
                                            <h2 style={{ padding: "0.75em 0" }}><Translate id="SkyMinder.OrderForm.Address" /></h2>
                                        </div>
                                        <div className="column is-12">
                                            <BbInput type="text" name="street" label={this.props.translate("SkyMinder.OrderForm.Street")} />
                                        </div>
                                        <div className="column is-12">
                                            <   BbInput type="text" name="city" label={this.props.translate("SkyMinder.OrderForm.City")} />
                                        </div>
                                        <div className="column is-12">
                                            <BbInput type="text" name="zipCode" label={this.props.translate("SkyMinder.OrderForm.Zip")} />
                                        </div>
                                    </div>
                                </div>
                                <div className="column is-6-widescreen is-12">
                                    <div className="columns is-centered is-multiline is-gapless">
                                        <div className="column is-12 skyminder-order-form-first-row">
                                            <BbInput type="text" name="companyId" disabled={true}
                                                label={this.props.translate("SkyMinder.OrderForm.Ico")}
                                            />
                                        </div>
                                        <div className="column is-12">
                                            <h2 style={{ padding: "0.75em 0" }}><Translate id="SkyMinder.OrderForm.ContactPerson" /></h2>
                                        </div>
                                        <div className="column is-12">
                                            <BbInput type="text" name="personName" label={this.props.translate("SkyMinder.OrderForm.PersonName")} />
                                        </div>
                                        <div className="column is-12">
                                            <BbInput type="text" name="personSurname"
                                                label={this.props.translate("SkyMinder.OrderForm.PersonSurname")}
                                            />
                                        </div>
                                        <div className="column is-12">
                                            <BbInput type="text" name="phone" label={this.props.translate("SkyMinder.OrderForm.Phone")} />
                                        </div>
                                        <div className="column is-12">
                                            <BbInput type="text" name="email" label={this.props.translate("SkyMinder.OrderForm.Email")} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="columns is-centered is-multiline skyminder-order-form-footer">
                                <div className="column is-12">
                                    <Translate id="SkyMinder.OrderForm.Warning" />
                                </div>
                                <div className="column is-12" style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <button type="submit" className={classnames('bb-button gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}>
                                        {this.state.orderStatus === orderStatus.submitting
                                            ? <FontAwesomeIcon icon="cog" spin />
                                            : <Translate id="SkyMinder.OrderForm.Send" />}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </Formik>
                {this.state.orderStatus === orderStatus.failed &&
                    <Message type="error" message={this.props.translate("SkyMinder.OrderForm.Error")} />}
            </Section>
        )
    }

    submitSearch = (values) => {
        this.setState({ orderStatus: orderStatus.submitting })
        apiPost(
            `${getHostApi()}/api/skyminder/order`,
            {},
            values,
            (success) => {
                success.error.code === 200
                    ? this.setState({ orderStatus: orderStatus.submitted })
                    : this.setState({ orderStatus: orderStatus.failed })
            },
            (error) => {
                writeErr(error);
                this.setState({ orderStatus: orderStatus.failed })
            }
        )
    }
}

export default withLocalize(withRouter(SkyminderComponent));